import {Group, Switch, Text} from "@mantine/core";
import {useLocalStorage} from "@mantine/hooks";
import {useTranslation} from "react-i18next";
import {LocalStorageKeys} from "../../../../types";
import classes from "./SettingSelectField.module.css";

export function InternalFeaturesToggle() {
    const {t} = useTranslation();
    const [showInternalFeatures, setShowInternalFeatures] = useLocalStorage({
        key: LocalStorageKeys.ShowInternalFeatures,
        defaultValue: false,
    });

    return (
        <Group className={classes.outer}>
            <Text className={classes.innerItem}>
                {t("settings.showInternalFeatures")}
            </Text>
            <Switch
                className={classes.innerItem}
                checked={showInternalFeatures}
                onChange={(event) =>
                    setShowInternalFeatures(event.currentTarget.checked)
                }
            />
        </Group>
    );
}
